const ForgotPassword = require("./containers/ForgotPassword");

module.exports = {
    path: "/forgot-password",
    component: ForgotPassword,
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/forgot-password/index.js